module.exports = __webpack_public_path__ + "static/img/icon_banner_main.1882d0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_banner_main.png
// module id = 3PJC
// module chunks = 1